import React from 'react'
import { Switch } from '@headlessui/react'
import clsx from 'clsx'
import { IssueCard } from '../../../../Elements/JirraIssue'
import { ListBoxWithCheck } from '../../../../Elements/Controls'
import type { Issue, ListBoxOption, AddedByResponse } from '../types'

export const IssueGrid: React.FC<{
  displayedIssues: Issue[]
  filters: {
    selectedType: ListBoxOption
    selectedEpic: ListBoxOption
    selectedStatus: ListBoxOption
    showStartingOnly: boolean
  }
  setFilters: {
    setSelectedType: (v: ListBoxOption) => void
    setSelectedEpic: (v: ListBoxOption) => void
    setSelectedStatus: (v: ListBoxOption) => void
    setShowStartingOnly: (v: boolean) => void
  }
  filterOptions: {
    issueTypes: ListBoxOption[]
    uniqEpics: ListBoxOption[]
    uniqStatuses: ListBoxOption[]
  }
  sprintId: string
  addedByLookup: Record<string, AddedByResponse>
  isLoadingAddedBy: boolean
  removedIssues: Issue[]
}> = ({ displayedIssues, filters, setFilters, filterOptions, sprintId, addedByLookup, isLoadingAddedBy, removedIssues }) => {
  return (
    <div>
      <div className='mb-4 flex items-center gap-3'>
        <Switch.Group as='div' className='flex items-center'>
          <Switch
            checked={filters.showStartingOnly}
            onChange={setFilters.setShowStartingOnly}
            className={clsx(
              filters.showStartingOnly ? 'bg-green-600' : 'bg-gray-200',
              'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-green-600 focus:ring-offset-2'
            )}
          >
            <span
              aria-hidden='true'
              className={clsx(
                filters.showStartingOnly ? 'translate-x-5' : 'translate-x-0',
                'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out'
              )}
            />
          </Switch>
          <Switch.Label as='span' className='ml-2 text-sm text-gray-600 whitespace-nowrap'>
            Starting only
          </Switch.Label>
        </Switch.Group>

        <div className='flex-1'>
          <ListBoxWithCheck
            values={filterOptions.uniqEpics}
            selected={filters.selectedEpic}
            setSelected={setFilters.setSelectedEpic}
          />
        </div>
        <div className='w-44'>
          <ListBoxWithCheck
            values={filterOptions.issueTypes}
            selected={filters.selectedType}
            setSelected={setFilters.setSelectedType}
          />
        </div>
        <div className='w-48'>
          <ListBoxWithCheck
            values={filterOptions.uniqStatuses}
            selected={filters.selectedStatus}
            setSelected={setFilters.setSelectedStatus}
          />
        </div>
      </div>
      <div className='grid grid-cols-1 gap-5 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4'>
        {displayedIssues.map(issue => (
          <IssueCard
            issue={issue}
            key={issue.id}
            sprintId={sprintId}
            removed={removedIssues.some(removedIssue => removedIssue.id === issue.id)}
            addedByLookup={addedByLookup}
            isLoadingAddedBy={isLoadingAddedBy}
          />
        ))}
      </div>
    </div>
  )
}